/**
 * G2 Awards module
 *
 * Listing of 5 G2 Awards which can be overridden from globaal modules
 */

// Deps
import { FelaComponent, createComponent } from "react-fela";
import { combineRules } from "fela";
import { gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { textStyles } from "~/styleguide/typography";
import get from "lodash.get";
import moduleData from "~/data/module-data.json";


// Components
import Visual from "~/components/shared/visual";
import { ContentMaxWidth } from "~/components/layout/max-width";

export default function G2Awards({ block }) {
    let { use_global_content, heading, columns, anchor_id, preload } = block;

    if (use_global_content) {
        // Grab the data from the Page or the Globals

        const contentObject = moduleData;
        const keyPrefix = use_global_content ? "data." : "";

        heading = get(contentObject, `${keyPrefix}acf.g2awards_heading`);
        columns = get(contentObject, `${keyPrefix}acf.g2awards_columns`);
    }

    return (
        <Container id={anchor_id} className="module-g2-awards">
            <ContentMaxWidth>
                {/* Heading */}
                { heading && (
                    <FelaComponent
                        as="div"
                        style={componentHeadingContainer}
                    >
                        {heading && (
                            <FelaComponent
                                as="h3"
                                style={combineRules(
                                    textStyles.heading3,
                                    componentHeading
                                )}
                            >
                                <span dangerouslySetInnerHTML={{ __html: heading }} />
                            </FelaComponent>
                        )}
                    </FelaComponent>
                )}


                <Columns
                    className="g2-image-column"
                >
                    {columns &&
                        columns.length &&
                        columns.map((column, index) => {
                            return (
                                <Column count={columns.length} key={index}>
                                    {/* Image */}
                                    {column.image && (
                                        <ImageContainer>
                                            <Visual
                                              image={column.image}
                                              load={preload}
                                            />
                                        </ImageContainer>
                                    )}

                                    {/* Heading */}
                                    {column.heading && (
                                        <FelaComponent
                                            as="h4"
                                            style={combineRules(
                                                textStyles.resourceHeading,
                                                imageColHeading
                                            )}
                                        >
                                            {column.heading}
                                        </FelaComponent>
                                    )}

                                    {/* Copy */}
                                    {column.copy && (
                                        <Copy
                                            extend={copyStyles}
                                            dangerouslySetInnerHTML={{
                                                __html: column.copy
                                            }}
                                        ></Copy>
                                    )}
                                </Column>
                            );
                        })}
                </Columns>
            </ContentMaxWidth>
        </Container>
    );
}

const Container = createComponent(
    () => ({
        textAlign: "center",

        extend: [
            fluid("paddingV", gutters.vertical),
            fluid("paddingH", gutters.default)
        ]
    }),
    "div",
    ["id"]
);

const Columns = createComponent(() => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    borderRadius: 24,
    padding: 60,
    background: "linear-gradient(93deg, #7549EA 0%, #422984 99.9%)",
}));

const Column = createComponent(({ count }) => ({
    minWidthMobileLandscape: {
        grid: {
            cols: "5",
            margins: "50",
            length: count,
            bottomMargin: 75
        }
    },
    maxWidthMobileLandscape: {
        width: "100%",
        maxWidth: 300,
        marginH: "auto",
        marginBottom: 50,
        grid: {
            cols: "3",
            margins: "30",
            length: count,
            bottomMargin: 30,
            lastElem: "auto"
        }
    }
}));

const ImageContainer = createComponent(() => ({
    position: "relative",
    width: "100%",
    maxWidth: 250,
    margin: "auto",
    "& .vv-visual": { height: "100%", width: "100%" },

    "& img": {
        width: "auto",
        margin: "auto",
        display: "block",
        overflow: "hidden"
    }
}));

const componentHeadingContainer = {
    extend: [fluid("marginBottom", { min: 20, max: 40 })]
};

const componentHeading = {
    marginH: "auto"
};


const Copy = createComponent(
    () => ({ ...textStyles.paragraph }),
    "div",
    ["dangerouslySetInnerHTML"]
);

const copyStyles = {};

const imageColHeading = {
    marginTop: 20,
    marginBottom: 12
};
